<script lang="ts">
import { Router, Route, Link } from "svelte-navigator";
import Layout from "./Layout.svelte";
import LoginPage from "./LoginPage.svelte";
import OpenRegistration from './OpenRegistration.svelte';
import Stage from "./Stage.svelte";
import Show from "./Show.svelte";
import AssetLibrary from "./AssetLibrary.svelte";
import PartnerLounge from "./PartnerLounge.svelte";
import Schedule from "./Schedule.svelte";
import Floor from "./Floor.svelte";
import LoginLayout from "./LoginLayout.svelte";
import PrivateRouteGuard from "./PrivateRouteGuard.svelte";
import HelpDesk from "./HelpDesk.svelte";
import ForgotPassword from "./ForgotPassword.svelte";
import SetPassword from "./SetPassword.svelte";
import Terms from "./Terms.svelte";
import { user } from "./store";
</script>

<Router>
  <!-- {#if $user}
    <PrivateRouteGuard>-->
      <Layout>
        <!-- <Route path="floor" component={Floor} /> -->
        <!-- <Route path="partners" component={PartnerLounge} /> -->
        <Route path="stage" component={Stage} />
        <Route path="show/:id" component={Show} />
        <Route path="help" component={HelpDesk} />
        <!-- <Route path="assets/*id"component={AssetLibrary} />
        <Route path="schedule" component={Schedule} />
        <Route path="terms" component={Terms} /> -->
        <!-- <Route path="*" component={Floor} /> -->
        <Route path="*" component={Stage} />
      </Layout>
    <!-- </PrivateRouteGuard>

  {:else}

    <LoginLayout> -->
      <!-- <Route path="signup" component={LoginPage} />
      <Route path="signin" component={LoginPage} /> -->
      <!-- <Route path="forgot" component={ForgotPassword} />
      <Route path="set-password" component={SetPassword} />
      <Route path="help" component={HelpDesk} />
      <Route path="terms" component={Terms} />
      <Route path="*" component={OpenRegistration} /> -->
      <!-- <Route path="*" component={LoginPage} /> -->
    <!-- </LoginLayout>
  {/if} -->
</Router>